import PropTypes from 'prop-types'

import Modal from '../../common/Modal'
import SubmitButton from '../../common/buttons/SubmitButton'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import classes from './DeleteEnrollmentModal.module.scss'

// Delete confirmation for an enrollment (Figma 1932-15253): warning triangle, title, message,
// and stacked Delete / Exit buttons.
const DeleteEnrollmentModal = ({ isOpen, onClose, onConfirm, isLoading, message }) => (
  <Modal isOpen={isOpen} onClose={onClose} className={classes.modal}>
    <div className={classes.content}>
      <WarningIcon className={classes.icon} />
      <h2 className={classes.title}>Delete Enrollment</h2>
      <p className={classes.message}>{message}</p>
      <SubmitButton
        buttonMessage='Delete Enrollment'
        buttonColor='orange-button'
        loading={isLoading}
        disabled={isLoading}
        onClick={onConfirm}
      />
      <SubmitButton buttonMessage='Exit' buttonColor='navy-button' onClick={onClose} />
    </div>
  </Modal>
)

DeleteEnrollmentModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
}

DeleteEnrollmentModal.defaultProps = {
  message: 'Are you sure you want to delete this enrollment?',
}

export default DeleteEnrollmentModal
